<!-- HEADER (top bar + curved menu + welcome banner + stats) -->
<home-header
  *ngIf="!coreConfig?.layout?.navbar?.hidden"
  [navbarPinned]="navbarPinned"
  (pinToggle)="onPinToggle()"
></home-header>

<!-- APP CONTENT -->
<div class="app-content content home-layout-content">
  <div class="content-overlay"></div>
  <content></content>
</div>

<!-- FOOTER -->
<footer
  *ngIf="!coreConfig?.layout?.footer?.hidden"
  class="footer"
  [ngClass]="
    coreConfig?.layout?.footer?.customBackgroundColor === true
      ? coreConfig.layout.footer.background + ' ' + coreConfig.layout.footer.type + ' ' + coreConfig.layout.footer.backgroundColor
      : coreConfig?.layout?.footer?.background + ' ' + coreConfig?.layout?.footer?.type
  "
></footer>
